import { Toaster as Sonner, toast } from "sonner"
import { useColorTheme } from "@/hooks/useColorTheme"

const Toaster = ({
  ...props
}) => {
  // Follow the app's colour theme so Sonner's built-in text colours stay readable on light themes
  const { isLight } = useColorTheme()

  return (
    <Sonner
      theme={isLight ? "light" : "dark"}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:!text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
